export default __webpack_public_path__ + "static/media/flux_tower.f082ba0a.webp";